import { apiRoutes } from '../../../api-routes';
import { publicHttpClient } from '../../../util/http-client';
import type { LoginRequestBody } from '../login-fn';

export interface LoginMethodResponse {
  login_methods: string[];
}

export const getLoginMethodFn = async (
  params: Pick<LoginRequestBody, 'client_type' | 'mobile' | 'imei'>
) => {
  const response = await publicHttpClient.post<LoginMethodResponse>(
    apiRoutes.auth.loginMethodV4,
    params
  );

  return response.data;
};
